import React, { useEffect, useState } from "react";
import Image from "../Reusable/Image";
import { SvgImages } from "../../Utils/LocalImages";
import { Link, useLocation } from "react-router-dom";
import RoutesPath from "../../Utils/RoutesPath";
import ApiService from "../../Services/ApiService";
import { handleApiErrors } from "../../Utils/Utils";

export default function Footer() {
  const [socialMediaLinks, setSocialMediaLinks] = useState();

  const getSocialContactInfo = async () => {
    try {
      const response = await ApiService.getSocialContactInfo();
      setSocialMediaLinks(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  }

  useEffect(() => { getSocialContactInfo() }, [])

  const quickLinks = [
    { id: 'about', label: 'About Us', to: RoutesPath.aboutUs },
    { id: 'services', label: 'Our Services', to: RoutesPath.services },
    { id: 'bharat-sat', label: 'Bharat SAT', to: RoutesPath.bharatSAT },
    { id: 'contact', label: 'Contact', to: RoutesPath.contactUs },
    { id: 'bharatSatScholarship', label: 'Bharat SAT Scholarship', to: RoutesPath.bharatSatScholarship },
    { id: 'join', label: 'Join & Earn', to: RoutesPath.joinAsCoordinator },
    { id: 'blog', label: 'Blog', to: RoutesPath.blog },
    { id: 'faq', label: "FAQ's", to: RoutesPath.faq },
    // { id: 'terms-and-conditions', label: 'Terms & Conditions', to: RoutesPath.termsAndConditions },
    { id: 'privacy-policy', label: 'Privacy Policy', to: RoutesPath.privacyPolicy },
    { id: 'cancellation-policy', label: 'Refund and Cancellation Policy', to: RoutesPath.cancellationPolicy },
  ];

  const location = useLocation();

  return (
    <div className="d-flex footer" >
      <div className="d-flex flex-column container align-items-start gap-3">
        <Image className="footerLogo mx-3 mb-0 mt-3" src={SvgImages.logoWhite} />

        <div className="row m-0 w-100">
          <div className="col-md-3 d-flex flex-column p-3">
            <p className='Sub-Heading white mb-0 w-100'>Pradnya Learn and Achieve Pvt Ltd. is dedicated to enhancing the educational experience of students across India. We invite you to join us on this remarkable journey to build a brighter future for the next generation.</p>
            <div className="d-flex flex-wrap gap-2 mt-3">
              {/* <Link to={socialMediaLinks?.facebook} target="_blank" rel="noopener noreferrer"> */}
                <div className="socialMediaIconContainer">
                  <Image className="socialMediaIcon" src={SvgImages.facebook} />
                </div>
              {/* </Link> */}

              {/* <Link to={socialMediaLinks?.instagram} target="_blank" rel="noopener noreferrer"> */}
                <div className="socialMediaIconContainer">
                  <Image className="socialMediaIcon" src={SvgImages.instagram} />
                </div>
              {/* </Link> */}

              {/* <Link to={socialMediaLinks?.linkedin} target="_blank" rel="noopener noreferrer"> */}
                <div className="socialMediaIconContainer">
                  <Image className="socialMediaIcon" src={SvgImages.linkedin} />
                </div>
              {/* </Link> */}

              {/* <Link to={socialMediaLinks?.twitter} target="_blank" rel="noopener noreferrer"> */}
                <div className="socialMediaIconContainer">
                  <Image className="socialMediaIcon" src={SvgImages.twitter} />
                </div>
              {/* </Link> */}

              {/* <Link to={socialMediaLinks?.youtube} target="_blank" rel="noopener noreferrer"> */}
                <div className="socialMediaIconContainer">
                  <Image className="socialMediaIcon" src={SvgImages.youtube} />
                </div>
              {/* </Link> */}
            </div>
          </div>

          <div className="col-md-3 col-6 d-flex flex-column p-3">
            <h3 className='large-text fw-400 white mb-3'>Quick Links</h3>
            <div className="d-flex flex-column gap-2 align-items-start">
              {quickLinks.map((tab, index) => (
                <Link
                  to={tab.to}
                  key={index}>
                  <h4
                    className='medium-text fw-400 white mb-0 clickable-link'
                    style={{ color: location.pathname === tab.to ? '#F6821F' : 'white' }}
                  >{tab.label}</h4>
                </Link>
              ))}
            </div>
          </div>

          <div className="col-md-3 col-6 p-3">
            <h3 className='large-text fw-400 white mb-3'>Get In Touch</h3>
            <div className="d-flex flex-column gap-3">

              <div className="d-flex align-items-center gap-2">
                <Image src={SvgImages.location} style={{ width: 20, marginBottom: 40 }} />
                <Link to={`https://maps.google.com/?q=${encodeURIComponent(socialMediaLinks?.location ?? "A301 UPTOWN AVENUE, Building NO.2, S.NO-743/2, Panvel, Raigad (MH)- 410206, Maharashtra.")}`} target="_blank" rel="noopener noreferrer">
                  <h4 className='medium-text fw-400 white mb-0 cursor-pointer clickable-link' style={{ overflowWrap: "anywhere" }}>
                    {socialMediaLinks?.location ?? "A301 UPTOWN AVENUE, Building NO.2, S.NO-743/2, Panvel, Raigad (MH)- 410206, Maharashtra."}
                  </h4>
                </Link>
              </div>
              <div className="d-flex align-items-center gap-2" >
                <Image src={SvgImages.email} style={{ width: 20 }} />
                <Link to={`mailto:${socialMediaLinks?.email ?? "info@learnandachieve.in"}`}>
                  <h4 className='medium-text fw-400 white mb-0 cursor-pointer clickable-link' style={{ overflowWrap: "anywhere" }}>{socialMediaLinks?.email ?? "info@learnandachieve.in"}</h4>
                </Link>
              </div>

              <div className="d-flex align-items-center gap-2" >
                <Image src={SvgImages.phone} style={{ width: 20 }} />
                <Link to={`tel:${socialMediaLinks?.phone ?? "883-0340425"}`}>
                  <h4 className='medium-text fw-400 white mb-0 cursor-pointer clickable-link'>{socialMediaLinks?.phone ?? "883-0340425"}</h4>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-3 position-relative footer-overlay-container">
            <Image className="footer-overlay-image" src={SvgImages.footerOverlay} />
          </div>
        </div>

        <div className="align-self-center" style={{ height: 1, backgroundColor: "#FFFFFF33", width: "calc(100% - 32px)" }}></div>
        <div className="d-flex align-items-center align-self-center">
          <p className='small-text white mb-0'>COPYRIGHT © {new Date().getFullYear()} PRADNYA LEARN AND ACHIEVE PVT LTD. ALL RIGHTS RESERVED. | POWERED BY :
            <Link to={"https://www.digihost.in"} target="_blank" rel="noopener noreferrer">
              <span className="small-text white mb-0 ms-1 clickable-link cursor-pointer">DIGIHOST</span>
            </Link>
          </p>

        </div>
      </div>
    </div>
  );
}
